import { Pipe, PipeTransform } from '@angular/core';

const LEVELS_GRADATION: Record<number, number> = {
  1: 9, // 1-9
  2: 19, // 10-19
  3: 29, // 20-29
  4: 39, // 30-39
  5: 49, // 40-49
  6: 60 // 50-60
};

@Pipe({
  name: 'levelColor'
})
export class LevelColorPipe implements PipeTransform {
  transform(level: number): string {
    for(const gradation in LEVELS_GRADATION) {
      const maxLevel: number = LEVELS_GRADATION[gradation];
      
      if(level <= maxLevel) {
        return `badge_lvl-gradation-${ gradation }`;
      }
    }

    return '';
  }
}
